import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RemoveProfileComponent } from './remove-profile.component';

const routes: Routes = [
  {
    path: '',
    component: RemoveProfileComponent,
  },
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RemoveProfileRoutingModule { }
